import { doApi } from './apiClient';
import type { Card, LeastOwnedCard, SellableCard } from '../types/models/card';

export const apiGetCards = (): Promise<Card[]> =>
  doApi<Card[]>('api/cards?order_by=date', 'GET');

export const apiGetCard = async (id: number): Promise<Card> => {
  const res = await doApi<Card | { data: Card }>(`api/cards/${id}`, 'GET');
  return 'data' in res && res.data ? res.data : res as Card;
};

export const apiCreateCard = (data: FormData): Promise<Card> =>
  doApi<Card>('api/cards', 'POST', data, true);

export const apiUpdateCard = (id: number, data: FormData): Promise<Card> =>
  doApi<Card>(`api/cards/${id}`, 'POST', data, true);

export const apiDeleteCard = (id: number): Promise<{ message: string }> =>
  doApi(`api/cards/${id}`, 'DELETE');

export const apiGetWrestlerCards = (wrestlerId: number): Promise<{ data: Card[] }> =>
  doApi<{ data: Card[] }>(`api/wrestlers/${wrestlerId}/cards`, 'GET');

export const apiGetShopCards = (): Promise<{ data: Card[] }> =>
  doApi<{ data: Card[] }>('api/cards/shop', 'GET');

export const apiBuyCard = (cardId: number): Promise<{ message: string; credits_remaining: number }> =>
  doApi(`api/cards/${cardId}/buy`, 'POST');

export const apiSetCardPrice = (
  cardId: number,
  fields: { price?: number | null; shop_disabled?: boolean }
): Promise<Card> =>
  doApi<Card>(`api/admin/cards/${cardId}/price`, 'PATCH', fields);

export interface SetAuthorByExpansionResult {
  message: string;
  cards_updated: number;
}

export const apiGetSellableCards = async (): Promise<SellableCard[]> => {
  const res = await doApi<SellableCard[] | { data: SellableCard[] }>('api/user/cards/sellable', 'GET');
  return Array.isArray(res) ? res : (res.data ?? []);
};

export interface SellCardResponse {
  message: string;
  credits_remaining: number;
}

export const apiSellCard = (
  cardId: number,
  quantity: number
): Promise<SellCardResponse> =>
  doApi<SellCardResponse>(`api/cards/${cardId}/sell`, 'POST', { quantity });

export const apiGetLeastOwnedCards = async (): Promise<LeastOwnedCard[]> => {
  const res = await doApi<LeastOwnedCard[] | { data: LeastOwnedCard[] }>('api/cards/least-owned', 'GET');
  return Array.isArray(res) ? res : (res.data ?? []);
};

export const apiSetAuthorByExpansion = (
  expansionId: number,
  authorUserId?: number | null,
  authorName?: string | null,
): Promise<SetAuthorByExpansionResult> =>
  doApi<SetAuthorByExpansionResult>('api/cards/set-author-by-expansion', 'POST', {
    expansion_id: expansionId,
    ...(authorUserId != null ? { author_user_id: authorUserId } : {}),
    ...(authorName ? { author_name: authorName } : {}),
  });
